import React from 'react'
import { FaExternalLinkAlt } from 'react-icons/fa'

const ProgressChecklist = ({
  document,
  section,
  sectionIndex,
  _showHeader = true,
  openByDefault = false,
  showInitialLinks = false,
}) => {
  const hasSectionStarted = section => {
    return section.steps.some(step => step.completed || step.current)
  }

  const allSectionStepsCompleted = section => {
    return section.steps.every(step => step.completed)
  }

  const canShowLink = currentStepIndex => {
    if (!showInitialLinks) return false

    // Find the first step without a value
    const firstIncompleteIndex = section.steps.findIndex(step => !step.value)

    // Allow links for all steps before the first incomplete one
    return currentStepIndex <= firstIncompleteIndex
  }

  return (
    <div
      id={`accordion-item-${sectionIndex}-${document.id}`}
      className={`accordion-item ${hasSectionStarted(section) ? '' : 'muted'}`}
      key={sectionIndex}
    >
      <h2
        className={`accordion-header d-inline-flex ${!hasSectionStarted(section) ? 'muted' : ''}`}
        id={`heading-${sectionIndex}-${document.id}`}
      >
        <button
          className={`accordion-button ${openByDefault ? '' : 'collapsed'} ${hasSectionStarted(section) ? '' : 'muted'}`}
          type='button'
          data-bs-toggle='collapse'
          data-bs-target={`#collapse-${sectionIndex}-${document.id}`}
          aria-expanded={openByDefault ? 'true' : 'false'}
          aria-controls={`collapse-${sectionIndex}-${document.id}`}
        >
          {section.name}
        </button>
      </h2>
      <div
        id={`collapse-${sectionIndex}-${document.id}`}
        className={`accordion-collapse collapse ${openByDefault ? 'show' : ''}`}
        aria-labelledby={`heading-${sectionIndex}-${document.id}`}
        data-bs-parent={`#accordion-${document.id}`}
        ref={el => {
          if (!el) return

          el.addEventListener('show.bs.collapse', () => {
            const accordionItem = window.document.getElementById(
              `accordion-item-${sectionIndex}-${document.id}`
            )
            const shouldBeMuted = !allSectionStepsCompleted(section)
            accordionItem.classList[shouldBeMuted ? 'add' : 'remove']('muted')
          })

          el.addEventListener('hide.bs.collapse', () => {
            const accordionItem = window.document.getElementById(
              `accordion-item-${sectionIndex}-${document.id}`
            )
            const shouldBeMuted = !hasSectionStarted(section)
            accordionItem.classList[shouldBeMuted ? 'add' : 'remove']('muted')
          })
        }}
      >
        {section.steps.map((step, stepIndex) => {
          const filingMethodsDisplay = step.filing_methods && step.filing_methods.length > 0 && (
            <div className='ms-3 mt-2'>
              {step.filing_methods.map(
                (filing, filingIndex) =>
                  filing.tracking_number && (
                    <div
                      key={filingIndex}
                      className='d-flex align-items-center mb-1 text-black gap-1'
                    >
                      <span className='me-2'>
                        {filing.address_type === 'ADDRESS_TO_COURT' ? 'Court:' : 'Law Firm:'}
                      </span>
                      <span className='py-1 rounded'>{filing.tracking_number}</span>
                      <a
                        href={`https://tools.usps.com/go/TrackConfirmAction?tRef=fullpage&tLc=2&text28777=&tLabels=${filing.tracking_number}&tABt=false`}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='inline-flex items-center text-blue-600 hover:underline'
                      >
                        <FaExternalLinkAlt className='ml-2 text-sm' aria-hidden='true' />
                      </a>
                    </div>
                  )
              )}
            </div>
          )

          return step.current && document.resume_url ? (
            <div key={stepIndex} className='accordion-body'>
              <a
                href={document.resume_url}
                className='text-decoration-none text-primary'
                data-remote='false'
                data-turbolinks='false'
              >
                <span>
                  {step.title}
                  {canShowLink(stepIndex) ? (
                    step.value ? (
                      <>
                        :{' '}
                        <a
                          href={step.url}
                          className='text-decoration-none text-primary'
                          data-remote='false'
                          data-turbolinks='false'
                        >
                          {step.value}
                        </a>
                      </>
                    ) : (
                      <>
                        :{' '}
                        <a
                          href={step.url}
                          className='text-decoration-none text-primary'
                          data-remote='false'
                          data-turbolinks='false'
                        >
                          &lt;edit&gt;
                        </a>
                      </>
                    )
                  ) : step.value ? (
                    `: ${step.value}`
                  ) : (
                    ''
                  )}
                </span>
              </a>
              {filingMethodsDisplay}
            </div>
          ) : (
            <div
              key={stepIndex}
              className={`accordion-body ${!step.completed && 'text-muted muted'}`}
            >
              {step.title}
              {canShowLink(stepIndex) ? (
                step.value ? (
                  <>
                    :{' '}
                    <a
                      href={step.url}
                      className='text-decoration-none text-primary'
                      data-remote='false'
                      data-turbolinks='false'
                    >
                      {step.value}
                    </a>
                  </>
                ) : (
                  <>
                    :{' '}
                    <a
                      href={step.url}
                      className='text-decoration-none text-primary'
                      data-remote='false'
                      data-turbolinks='false'
                    >
                      &lt;edit&gt;
                    </a>
                  </>
                )
              ) : step.value ? (
                `: ${step.value}`
              ) : (
                ''
              )}
              {filingMethodsDisplay}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ProgressChecklist
